import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table, Input, Row, Col } from "reactstrap";
import Moment from "react-moment";
import moment from "moment-timezone";
import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";

function ListCreditsModal({ show, toggle, credits, setCredits, loadCredits }) {
    const usedOptions = [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 2 },
    ];
    const [filter, setFilter] = useState({
        usedValue: 1
    });
    const [formEntries, setFormEntries] = useState([{
        date: new Date().toISOString().split("T")[0],
        description: "",
        amount: 0,
        requiredAmount: false,
        editable: false,
    }]);
    const editCredit = (index) => {
        credits[index].editable = true;
        setCredits([...credits]);
    };
    const saveCredit = (index) => {
        let findCredit = credits.find((credit, i) => i === index);
        PostApiWithAuthorizationAction(`credits/update/${findCredit.id}`, {
            date: findCredit.createdAt,
            description: findCredit.description,
            amount: findCredit.amount
        }).then((res) => {
            loadCredits();
        }).finally(() => {
            credits[index] = findCredit;
            credits[index].createdAt = moment(findCredit.createdAt).tz("America/Los_Angeles").toDate();
            credits[index].editable = false;
            setCredits([...credits]);
        });
    };
    const deleteCredit = (id) => {
        // Implement the delete logic here
        PostApiWithAuthorizationAction("credits/delete", {
            id: id
        }).then((res) => {
            // remove the deleted credit from the list
            const _credits = credits.filter((credit) => credit.id !== id);
            setCredits([..._credits]);
        }).finally(() => {
            loadCredits();
        });
    };
    const addItemsHandler = (index) => {
        let findCredit = formEntries.find((credit, i) => i === index);
        let amount = parseFloat(findCredit.amount);
        if (isNaN(amount) || amount === 0) {
        findCredit.requiredAmount = true;
        formEntries[index] = findCredit;
        setFormEntries([...formEntries]);
        } else {
        setFormEntries([...formEntries, {
            date: new Date().toISOString().split("T")[0],
            description: "",
            amount: 0,
            requiredAmount: false,
        }]);
        }
    };
    const removeRowInItem = (index) => {
        const newCredits = [...formEntries];
        newCredits.splice(index, 1);
        setFormEntries(newCredits);
    };
    const submitHandler = () => {
        let allNotValid = formEntries.some(credit => isNaN(credit.amount) || credit.amount === 0);
        if (allNotValid) {
        toast.error("Some credits are not valid");
        return;
        }
        // You can add your API call or further processing logic here for the valid credits
        PostApiWithAuthorizationAction("common/create-new-credit", {
            credits: formEntries
        }).then((res) => {
            setFormEntries([{
                date: new Date().toISOString().split("T")[0],
                description: "",
                amount: 0,
                requiredAmount: false,
            }]);
            loadCredits();
        });
    };
    const renderForm = () => {
        return formEntries.map((credit, index) => (
        <tr key={index}>
            <td>
                <Input
                    bsSize="lg"
                    type="date"
                    value={credit.date}
                    onChange={(e) => {
                    const newCredits = [...formEntries];
                    newCredits[index].date = e.target.value;
                    setFormEntries(newCredits);
                    }}
                />
            </td>
            <td>
                <Input
                    placeholder="Description"
                    value={credit.description}
                    style={{ width: "250px" }}
                    onChange={(e) => {
                    const newCredits = [...formEntries];
                    newCredits[index].description = e.target.value;
                    setFormEntries(newCredits);
                    }}
                />
            </td>
            <td>
                <Input
                    placeholder="Amount"
                    type="number"
                    value={credit.amount}
                    style={{ width: "100px", borderColor: credit.requiredAmount ? "red" : "" }}
                    onChange={(e) => {
                    const newCredits = [...formEntries];
                    newCredits[index].amount = parseInt(e.target.value);
                    setFormEntries(newCredits);
                    if (newCredits[index].amount === 0) {
                        newCredits[index].requiredAmount = true;
                    } else {
                        newCredits[index].requiredAmount = false;
                    }
                    }}
                />
            </td>
            <td style={{ verticalAlign: "top" }}>
                {(index === formEntries.length - 1) && (
                <Button
                    className="icon-cross"
                    id="add-item"
                    color="primary"
                    onClick={(e) => {
                    addItemsHandler(index);
                    }}
                >
                    <i class="fas fa-plus-square"></i>
                </Button>
                )}
                {(formEntries.length > 1)&& (
                <Button
                    id="remove"
                    className="icon-cross"
                    color="danger"
                    title="remove"
                    onClick={() => {
                    removeRowInItem(index);
                    }}
                >
                    <i className="fas fa-times"></i>
                </Button>)}
            </td>
        </tr>
        ));
    };
    const renderHTML = () => {
        return credits.map((credit, index) => (
            <tr key={index}>
                <td>
                    {credit.editable ? (
                        <Input
                            bsSize="sm"
                            type="date"
                            value={moment(credit.createdAt).format("YYYY-MM-DD")}
                            onChange={(e) => {
                                const newCredits = [...credits];
                                newCredits[index].createdAt = e.target.value;
                                setCredits([...newCredits]);
                            }}
                        />
                    ) : (
                        <Moment format="MM/DD/YY HH:mm" tz="America/Los_Angeles">
                            {credit.createdAt.toString().length === 10
                                ? new Date(credit.createdAt * 1000)
                                : new Date(credit.createdAt)}
                        </Moment>
                    )}
                </td>
                <td>
                    {credit.editable ? (
                        <Input
                            placeholder="Description"
                            value={credit.description}
                            style={{ width: "250px" }}
                            onChange={(e) => {
                            const newCredits = [...credits];
                            newCredits[index].description = e.target.value;
                            setCredits(newCredits);
                            }}
                        />
                    ) : (
                        credit.description
                    )}
                </td>
                <td>
                    {credit.editable ? (
                        <Input
                            placeholder="Amount"
                            type="number"
                            value={credit.amount}
                            style={{ width: "100px", borderColor: credit.requiredAmount ? "red" : "" }}
                            onChange={(e) => {
                            const newCredits = [...credits];
                            newCredits[index].amount = parseInt(e.target.value);
                            setCredits(newCredits);
                            if (newCredits[index].amount === 0) {
                                newCredits[index].requiredAmount = true;
                            } else {
                                newCredits[index].requiredAmount = false;
                            }
                            }}
                        />
                    ) : (
                        credit.amount
                    )}
                </td>
                <td>
                    {credit.editable ? (
                        <Button
                            color="success"
                            size="sm"
                            onClick={() => {
                                saveCredit(index);
                            }}>
                            <i className="fas fa-save"></i>
                        </Button>
                    ) : (
                    <>
                        <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                                editCredit(index);
                            }}>
                            <i className="fas fa-edit"></i>
                        </Button>
                        <Button
                            color="danger"
                            size="sm"
                            onClick={() => {
                                if (window.confirm('Are you sure you want to delete this credit?')) {
                                    deleteCredit(credit.id);
                                }
                            }}>
                            <i className="fas fa-trash"></i>
                        </Button>
                    </>)}
                </td>
            </tr>
        ));
    };
    return (
        <Modal isOpen={show} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>List of Credits</ModalHeader>
            <ModalBody>
                <Row>
                    <Col md="3" lg="6" xl="3">
                        <Table className="desc-table" borderless>
                            <thead>
                            <tr>
                                <td>Date</td>
                                <td>Description</td>
                                <td>Amount</td>
                                <td></td>
                            </tr>
                            </thead>
                            <tbody>{renderForm()}</tbody>
                            <tfoot>
                                <td colSpan={3}></td>
                                <td style={{textAlign: 'left'}}>
                                    <Button
                                        id="add-btn"
                                        color="primary"
                                        size="sm"
                                        onClick={(e) => {
                                            submitHandler();
                                        }}
                                    >Add</Button>
                                </td>
                            </tfoot>
                        </Table>
                    </Col>
                </Row>
                <h2>History</h2>
                <div className="history-table">
                    <div className="table-filter-right">

                    </div>
                    <Table
                        className="ticket-table table-listing table table-bordered table-striped"
                        borderless>
                        <thead>
                        <tr>
                            <td>Date</td>
                            <td>Description</td>
                            <td>Amount</td>
                            <td>Actions</td>
                        </tr>
                        </thead>
                        <tbody>{renderHTML()}</tbody>
                    </Table>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Close</Button>
            </ModalFooter>
        </Modal>
    );
}

export default ListCreditsModal;